"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifQuestionWithLabel = void 0;
const ifQuestionWithLabel = (label) => {
    return {
        answerEquals(answer) {
            return {
                renderTheseQuestions(questions) {
                    return questions.map((question) => question.renderIf(answer, { label: label }, true));
                },
            };
        },
    };
};
exports.ifQuestionWithLabel = ifQuestionWithLabel;
